import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import * as Icon from '@mui/icons-material/';
import { createBrowserHistory } from 'history';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import CategoriaFinanceiraController from '../../../../controllers/CategoriaFinanceiraController';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

export default function CategoriaFinanceiraCadastrar() {
  const { userId } = useSelector((state: any) => state.Authentication);

  const history = createBrowserHistory();
  const [single, setSingle] = useState<any>(null);
  const { id } = useParams()
  const CategoriaFinanceiraId = id ? parseInt(id, 10) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  useEffect(() => {

  if (CategoriaFinanceiraId != null) {
    getSingle(CategoriaFinanceiraId);
  }
  }, [CategoriaFinanceiraId]);

  const getSingle = async (CategoriaFinanceiraId: number) => {
    const Response = await CategoriaFinanceiraController.ListarUnico(
      CategoriaFinanceiraId
    );

    setSingle(Response.Data);
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    if (!id) {
      const response = await CategoriaFinanceiraController.Adicionar(values);

      if (response.StatusCode === 204) {
        toast('Categoria Financeira incluído com sucesso!', {
          type: 'success',
        })
        resetForm();
      } else {
        toast('Erro ao incluir a categoria financeira!', {
          type: 'error',
        })
        resetForm();
      }
    } else {
      EditarContato(values, { setSubmitting, resetForm });
    }

    setSubmitting(false);
  };

  const EditarContato = async (
    values: any,
    { setSubmitting }: any
  ) => {
    const request = {
      CategoriaFinanceiraId: CategoriaFinanceiraId,
      ...values,
    };

    const response = await CategoriaFinanceiraController.Atualizar(request);

    if (response.StatusCode === 204) {
      toast('Categoria Financeira atualizada com sucesso!', {
        type: 'success',
      })
    } else {
      toast('Erro ao atualizar a categoria financeira!', {
        type: 'error',
      })
    }
    setSubmitting(false);
  };

  const initialValues = {
    UsuId: userId,
    Descricao: single?.cfi_descricao || '',
    Tipo: single?.cfi_tipo || '',
    CategoriaFinanceiraIdPai: single?.cf_idPai || '',
  };

  const validationSchema = Yup.object().shape({
    Descricao: Yup.string()
      .required('Campo Obrigatório!')
      .min(3, 'O Campo deve ter no mínimo 3 caracteres'),
    Tipo: Yup.string(), //.typeError("Por favor, insira um CPF ou CNPJ válido"),
  });

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <HeaderComponent text={'CADASTRO DE CATEGORIA FINANCEIRA'} className={'mb-5'} />

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors }) => (
          <Form>
            <BoxButtons>
              <Button
                variant='contained'
                onClick={() => history.back()}
                color='warning'
                startIcon={<Icon.ArrowBack />}
              >
                Voltar
              </Button>
              <Button
                type={'submit'}
                variant='contained'
                color='success'
                startIcon={<Icon.Save />}
                disabled={duploClick}
              >
                Salvar
              </Button>
            </BoxButtons>
            <fieldset disabled={duploClick}>
            <Field
              name='CategoriaFinanceiraIdPai'
              as={TextField}
              id='outlined-password-input'
              label='Código Pai'
              type='number'
              error={Boolean(errors?.CategoriaFinanceiraIdPai)}
              helperText={errors?.CategoriaFinanceiraIdPai}
            />
            <Field
              name='Descricao'
              as={TextField}
              label='Descricao'
              type='text'
              error={Boolean(errors?.Descricao)}
              helperText={errors?.Descricao}
            />
            <Field
              name='Tipo'
              as={TextField}
              id='outlined-password-input'
              label='Tipo'
              type='number'
              error={Boolean(errors?.Tipo)}
              helperText={errors?.Tipo}
            />
            </fieldset>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
